import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslation from '../locales/en.json';
import faTranslation from '../locales/fa.json';

const resources = {
  en: {
    translation: enTranslation,
  },
  fa: {
    translation: faTranslation,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en', // زبان پیش‌فرض در صورت عدم تشخیص
    detection: {
      order: ['localStorage', 'navigator'], // اولویت: اول localStorage، بعد زبان مرورگر
      caches: ['localStorage'], // ذخیره زبان تو localStorage
      lookupLocalStorage: 'i18nextLng', // کلید ذخیره‌سازی تو localStorage
    },
    interpolation: {
      escapeValue: false, // React خودش XSS رو مدیریت می‌کنه
    },
  });

i18n.on('languageChanged', (lng) => {
  document.body.setAttribute('dir', lng === 'fa' ? 'rtl' : 'ltr');
});

export default i18n;